# Receipts

When a user makes a decision through a component, the component transitions to a **receipt state** -- a compact, read-only summary of what was decided. Receipts are permanent records.

## Why receipts matter

Chat scrolls. The user might make a decision at message 5 and need to reference it at message 20. Receipts ensure that past decisions remain visible and citable.

The assistant's follow-up should reference the receipt and, when appropriate, offer a way to undo or modify the decision.

## How it works

Pass a `choice` prop to switch any interactive component into receipt mode:

```tsx
<ApprovalCard
  title="Back up database"
  choice={{ decision: "approved", timestamp: "2026-03-08T10:00:00Z" }}
/>
```

The component renders a one-line summary instead of the full interactive surface.

## Components with receipt states

| Component     | Receipt Prop | What It Shows                 |
| ------------- | ------------ | ----------------------------- |
| Approval Card | `choice`     | The decision and action title |
| Option List   | `choice`     | Only the selected option(s)   |
| Data Table    | `choice`     | Summary of selected rows      |

## Writing receipt copy

Receipt copy describes a past decision.

**Decision labels use past tense**: Approved, Denied, Selected, Confirmed.

**Action descriptions stay imperative**: they describe the request, not the outcome.

Examples:

- "Approved: Back up database"
- "Denied: Delete all project files"
- "Selected: Merge duplicates"

## When to use receipts

Use receipts for decisions that:

- Change state (approvals, deletions, submissions)
- Can't be easily undone
- The user or assistant might need to reference later

Skip receipts for reversible controls like sorting, filtering, or adjusting parameters.
